import {
  FETCH_LOG,
  FETCH_LOG_SUCCESS,
  FETCH_LOG_ERROR,
  ADD_LOG,
  ADD_LOG_SUCCESS,
  ADD_LOG_ERROR,
} from 'constants/ActionTypes'

const INIT_STATE = {
  error: '',
  loading: false,
  data: [],
  updating: false,
  payload: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_LOG: {
      return {...state, error: '', loading: true};
    }
    case ADD_LOG: {
      return {...state, error: '', updating: true};
    }
    case FETCH_LOG_SUCCESS: {
      return {...state, error: '', data: action.payload, loading: false};
    }
    case ADD_LOG_SUCCESS: {
      return {...state, error: '', updating: false, payload: { code: 200, message: 'Thêm dữ liệu thành công!' }};
    }
    case FETCH_LOG_ERROR: {
      return {...state, loading: false, error: action.payload};
    }
    case ADD_LOG_ERROR: {
      return {...state, updating: false, error: action.payload, payload: { code: 500, message: 'Có lỗi trong quá trình xử lý!' }};
    }
    default:
      return state;
  }
}
